import { Button, icons } from "@bruntworkwear-apps/ui";
import styles from "../FeedbackDialog.module.css";

interface DialogHeaderProps {
  title: string;
  /** Id the dialog points `aria-labeledby` at. */
  titleId: string;
  /** Closing mid-send would leave a report in flight with nothing watching it. */
  disabled: boolean;
  onClose: () => void;
}

/** The dialog's title bar. Sticky, so the close button survives a scroll. */
export function DialogHeaderView({ title, titleId, disabled, onClose }: DialogHeaderProps) {
  return (
    <div className={styles.header}>
      <h2 className={styles.title} id={titleId}>
        {title}
      </h2>
      <Button
        variant="ghost"
        aria-label="Close"
        onClick={onClose}
        disabled={disabled}
        leadingIcon={<icons.X size={16} aria-hidden />}
      />
    </div>
  );
}
